import { gql } from "@apollo/client";

export const Get_Reports = gql`
  query GetReports(
    $skip: Int
    $take: Int
    $where: ReportFilterInput
    $order: [ReportSortInput!]
  ) {
    reports(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        reportTemplateId
        filterJson
        createdOn
        modifiedOn
        isFavourite
        isDeleted
        createdBy
        lastViewed
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
export const Get_Favorite_Reports = gql`
  query GetFavReports(
    $userId: Int!
    $skip: Int
    $take: Int
    $where: ReportFilterInput
    $order: [ReportSortInput!]
  ) {
    favoriteReports(
      userId: $userId
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        id
        name
        reportTemplateId
        filterJson
        createdOn
        modifiedOn
        isFavourite
        isDeleted
        createdBy
        lastViewed
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const Get_Favorite_Count_Reports = gql`
  query GetFavReports(
    $userId: Int!
    $skip: Int
    $take: Int
    $where: ReportFilterInput
    $order: [ReportSortInput!]
  ) {
    favoriteReports(
      userId: $userId
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        id
      }
    }
  }
`;
export const Get_Report_Templates = gql`
  query GetReportTemplates(
    $skip: Int
    $take: Int
    $where: ReportTemplateFilterInput
    $order: [ReportTemplateSortInput!]
  ) {
    reportTemplates(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        uuid
        createdOn
        modifiedOn
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

// ================= Dashboard Queries =====================

export const Get_Dashboards = gql`
  query GetDashboards(
    $skip: Int
    $take: Int
    $where: DashboardFilterInput
    $order: [DashboardSortInput!]
  ) {
    dashboards(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        createdOn
        userDisplayName
        dashboardTemplateType
        reports {
          id
          name
          reportTemplateId
          filterJson
          createdOn
          isDeleted
        }
      }
    }
  }
`;

export const Get_Dashboards_Count = gql`
  query {
    dashboards {
      totalCount
    }
  }
`;

export const Get_Default_Dashboard = gql`
  query GetDefaultDashboard($id: Int) {
    dashboards(where: { id: { eq: $id } }) {
      totalCount
    }
  }
`;

// ======================reports templates queries
export const Recent_Activity_Created_Leads = gql`
  query RecentActivityCreatedLeads(
    $skip: Int
    $take: Int
    $where: ActivityOfRecentlyCreatedLeadsFilterInput
    $order: [ActivityOfRecentlyCreatedLeadsSortInput!]
  ) {
    recentActivityCreatedLeads(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      items {
        leadId
        leadName
        leadStatusChangedBy
        leadStatusChangedOn
        leadStatus
        companyKey
        leadSourceId
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
export const Get_Unassigned_Leads = gql`
  query GetUnassignedLeads(
    $skip: Int
    $take: Int
    $where: UnassignedLeadsFilterInput
    $order: [UnassignedLeadsSortInput!]
  ) {
    unassignedLeadsReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        id
        leadName
        createdBy
        createdOn
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const Get_Leads_By_Location = gql`
  query GetLeadsByLocation(
    $skip: Int
    $take: Int
    $where: LeadsByLocationFilterInput
    $order: [LeadsByLocationSortInput!]
  ) {
    leadsByLocationReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        countryId
        stateProvinceId
        city
        leadCount
        leadCreatedOnDateOnly
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const Get_Leads_Generated = gql`
  query GetLeadsGenerated(
    $skip: Int
    $take: Int
    $where: LeadsGeneratedFilterInput
    $order: [LeadsGeneratedSortInput!]
  ) {
    leadsGeneratedReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        createdOn
        leadSourceId
      }
    }
  }
`;
export const Get_Leads_Contacted_By_Team_Member = gql`
  query GetLeadsContactedByTeamMember(
    $skip: Int
    $take: Int
    $where: LeadsContactedByTeamMemberFilterInput
    $order: [LeadsContactedByTeamMemberSortInput!]
  ) {
    leadsContactedByTeamMemberReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        leadSourceId
        leadStatusId
        teamMemberId
        overTime
      }
    }
  }
`;
export const Get_Avg_Lead_Response_Time = gql`
  query GetAvgLeadResponseTime(
    $skip: Int
    $take: Int
    $where: AvgLeadResponseTimeFilterInput
    $order: [AvgLeadResponseTimeSortInput!]
  ) {
    avgLeadResponseTimeReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        outreachType
        avgResponseTimeMinutes
        leadStatusId
        leadOwnerId
        totalLeads
        firstOutreachTime
      }
    }
  }
`;
export const Get_Mql_Leads_By_First_Outreach = gql`
  query GetMqlLeadsByFirstOutreach(
    $skip: Int
    $take: Int
    $where: MQLLeadsByFirstOutreachFilterInput
    $order: [MQLLeadsByFirstOutreachSortInput!]
  ) {
    mqlLeadsByFirstOutreachReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        leadSourceId
        qualifiedLead
        teamMemberId
        overTime
        countryId
        stateProvinceId
        city
        qualifiedLead
      }
    }
  }
`;
export const Get_Email_Conversations_OverTime = gql`
  query GetEmailConversationsOverTime(
    $skip: Int
    $take: Int
    $where: EmailConversationsOverTimeFilterInput
    $order: [EmailConversationsOverTimeSortInput!]
  ) {
    emailConversationsOverTime(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        messageId
        leadSourceId
        teamMemberId
        emailSentDate
      }
    }
  }
`;
export const Get_Leads_Not_Contacted = gql`
  query GetLeadsNotContacted(
    $skip: Int
    $take: Int
    $where: LeadsNotContactedFilterInput
    $order: [LeadsNotContactedSortInput!]
  ) {
    leadsNotContactedReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        leadName
        companyKey
        assignedTo
        dateOfLeadGeneration
        leadSourceId
      }
    }
  }
`;

export const Get_Avg_Email_Open_Rate = gql`
  query GetAvgEmailOpenRate(
    $skip: Int
    $take: Int
    $where: AvgEmailOpenRateFilterInput
    $order: [AvgEmailOpenRateSortInput!]
  ) {
    avgEmailOpenRateReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        companyKey
        leadId
        leadSourceId
        industryId
        countryId
        stateProvinceId
        city
        emailSentDate
        openRate
      }
    }
  }
`;

export const Get_Active_Workflows_Activity = gql`
  query GetActiveWorkflowsActivity(
    $fetchAll: Boolean! = false
    $skip: Int
    $take: Int
    $where: ActiveWorkflowsActivityFilterInput
    $order: [ActiveWorkflowsActivitySortInput!]
  ) {
    activeWorkflowsActivityReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
      fetchAll: $fetchAll
    ) {
      workFlowId
      activityType
      activityTypeId
      leadCount
      activityDate
    }
  }
`;
export const Get_Active_Workflow_With_Leads = gql`
  query GetActiveWorkflowWithLeads(
    $skip: Int
    $take: Int
    $where: ActiveWorkflowsWithLeadsFilterInput
    $order: [ActiveWorkflowsWithLeadsSortInput!]
  ) {
    activeWorkflowsWithLeadsReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        workflowName
        workflowCreatedOn
        numberOfLeadsEnrolled
        companyKey
      }
    }
  }
`;
export const Get_Lead_Lists_In_Workflows = gql`
  query GetLeadListsInWorkflows(
    $skip: Int
    $take: Int
    $where: LeadListsInWorkflowsFilterInput
    $order: [LeadListsInWorkflowsSortInput!]
  ) {
    leadListsInWorkflowsReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadList
        createdOn
        createdBy
        workflowUsedIn
        companyKey
      }
    }
  }
`;

export const Get_SMS_Sent = gql`
  query GetSMSSentReport(
    $skip: Int
    $take: Int
    $where: SMSSentFilterInput
    $order: [SMSSentSortInput!]
  ) {
    smsSentReport(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        leadName
        leadSourceId
        city
        status
        createdOn
      }
    }
  }
`;
export const Get_SMS_Received = gql`
  query GetSMSReceivedReport(
    $skip: Int
    $take: Int
    $where: SMSReceivedFilterInput
    $order: [SMSReceivedSortInput!]
  ) {
    smsReceivedReport(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        leadName
        createdOn
        city
      }
    }
  }
`;

export const Get_Email_Sent = gql`
  query GetEmailSentReport(
    $skip: Int
    $take: Int
    $where: EmailSentFilterInput
    $order: [EmailSentSortInput!]
  ) {
    emailSentReport(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      items {
        leadName
        leadSourceId
        countryId
        stateProvinceId
        city
        email
        isOpened
        createdOn
      }
    }
  }
`;

export const Get_Email_Received = gql`
  query GetEmailReceivedReport(
    $skip: Int
    $take: Int
    $where: EmailReceivedFilterInput
    $order: [EmailReceivedSortInput!]
  ) {
    emailReceivedReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadName
        email
        createdOn
        status
        countryId
        stateProvinceId
        city
      }
    }
  }
`;

export const Get_Appointment_Scheduled = gql`
  query GetAppointmentScheduledReport(
    $skip: Int
    $take: Int
    $where: AppointmentScheduledFilterInput
    $order: [AppointmentScheduledSortInput!]
  ) {
    appointmentScheduledReport(
      skip: $skip
      take: $take
      where: $where
      order: $order
    ) {
      totalCount
      items {
        leadId
        title
        leadName
        leadSourceId
        createdBy
        memberId
        createdOn
        startDate
        endDate
      }
    }
  }
`;
